import { LOG_LEVEL } from "./logLevel";
export default {
    [LOG_LEVEL.DEBUG]: "Диагностика",
    [LOG_LEVEL.INFO]: "Информация",
    [LOG_LEVEL.WARNING]: "Предупреждение",
    [LOG_LEVEL.ERROR]: "Ошибка"
};
